import { apiClient, ApiResponse } from './client';

export const getLicense = async (session_id: string): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: '/license/current',
    data: JSON.stringify({ session_id }),
  });
};

export const getPricing = async (session_id: string): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: '/license/pricing',
    data: JSON.stringify({ session_id }),
  });
};

export const assignPaidLicense = async (order_id: string, session_id: string): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: '/license/assign',
    data: JSON.stringify({ 
      order_id, 
      session_id, 
      license_type: 'paid',
      payment_processor: 'paypal'
    }),
  });
};

export const cancelPayPalSubscription = async (
  session_id: string, 
  subscription_id: string, 
  customer_reason: string
): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: '/paypal/subscription/cancel',
    data: JSON.stringify({ 
      session_id,
      subscription_id,
      customer_reason
    }),
  });
};

export const createStripeCheckout = async (
  productKey: string,
  session_id: string
): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: '/stripe/create-checkout',
    data: JSON.stringify({
      productKey,
      session_id,
    }),
  });
};

export const checkStripeCheckoutStatus = async (
  checkout_session_id: string,
  session_id: string
): Promise<ApiResponse> => {
  return apiClient.request({
    method: 'POST',
    url: '/stripe/checkout-status',
    data: JSON.stringify({
      checkout_session_id,
      session_id,
    }),
  });
}; 